<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="4" style="text-align: start">
                <strong v-if="status_form==0">{{ $t('components.addArea') }}</strong>
                <strong v-else>{{ $t('buttons.editArea') }} </strong>
              </CCol>
              <CCol col="4" style="text-align: center">
                <strong v-if="status_form!=0">{{ edit_name }}</strong>
              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton v-if="status_form ==0" @click="insert_data()"
                         type="submit" class="mr-1 ml-1" size="sm" color="secondary">
                  {{ $t('buttons.submit') }}
                </CButton>
                <CButton v-if="status_form !=0" @click="insert_data()"
                         type="submit" size="sm" color="secondary">
                  {{ $t('buttons.edit') }}
                </CButton>
                <!--                <a :href="$route.fullPath" target="_blank">-->
                <!--                  <CButton-->
                <!--                      class="mr-1"-->
                <!--                      size="sm"-->

                <!--                      color="dark"-->
                <!--                  >-->
                <!--                    <CIcon size="sm" name="cil-plus"></CIcon>-->
                <!--                  </CButton>-->
                <!--                </a>-->
                <CButton v-if="status_form!=0"
                         @click="emptyList()"
                         class="mr-1"
                         size="sm"
                         color="secondary"
                >{{ $t("buttons.cancel") }}
                </CButton>
              </CCol>
            </CRow>
          </CCardHeader>

          <CCardBody>
            <CForm>

              <CRow>
                <CCol col="4">
                  <CSelect
                      :label="$t('Country')"
                      :value.sync="selected_country"
                      horizontal

                      :options="country_items"
                  />
                  <CSelect
                      :label="$t('components.province')"
                      horizontal
                      :options="province_items"
                      :value.sync="selected_province"/>

                  <CSelect
                      :label="$t('components.city')"
                      horizontal
                      :options="city_items"
                      :value.sync="selected_city"/>

                  <CSelect
                      :label="$t('town')"
                      :value.sync="selected_district"
                      horizontal
                      :options="district_items"
                  />
                  <CInput
                          :label="$t('components.areaName')"
                          horizontal
                          v-model="name"
                          autocomplete="name"

                  />
                </CCol>
                <CCol col="8" v-if="get_access('area_map')">
                  <div :style="{ height: '150px'}" id='map'></div>

                </CCol>
              </CRow>


            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow
        v-show="this.$route.fullPath == '/dashboard/base/address/settings' || this.$route.fullPath.startsWith('/dashboard/sale-orders/sale-settings')">
      <CCol col="10">
        <CCard>
          <CCardHeader>
            <strong>{{ $t('components.areaList') }}</strong>
          </CCardHeader>
          <CCardBody>
<!--            <CRow>-->
<!--              <CCol>-->
<!--                <CSelect-->
<!--                    :label="$t('Country')"-->
<!--                    :value.sync="selected_country2"-->
<!--                    horizontal-->

<!--                    :options="country_items"-->
<!--                />-->
<!--              </CCol>-->
<!--              <CCol>-->

<!--                <CSelect-->
<!--                    :label="$t('components.province')"-->
<!--                    horizontal-->
<!--                    :options="province_items2"-->
<!--                    :value.sync="selected_province2"/>-->
<!--              </CCol>-->
<!--              <CCol>-->

<!--                <CSelect-->
<!--                    :label="$t('components.city')"-->
<!--                    horizontal-->
<!--                    :options="city_items2"-->
<!--                    :value.sync="selected_city2"/>-->
<!--              </CCol>-->
<!--              <CCol>-->

<!--                <CSelect-->
<!--                    :label="$t('Town')"-->
<!--                    :value.sync="selected_district2"-->
<!--                    horizontal-->
<!--                    :options="district_items2"-->
<!--                />-->
<!--              </CCol>-->
<!--            </CRow>-->
            <CDataTable
                :items="items"
                :fields="fields"
                column-filter
                border
                style="height: 250px;overflow: auto"
                @row-clicked="table_row_clicked"

                striped
                :items-per-page="20"
                hover
                sorter
                pagination
            >
              <template #row_id="{item}">

                <td style="text-align: center">
                  <p >{{ item.row_id + 1 }}</p>

                </td>

              </template>
              <template #operation="{item,index}">
                <td>

                  <!--                    <CIcon @click.native="edit_item(item)" class=" mr-1 text-primary" name="cil-pencil"/>-->

                  <!--                    <CIcon @click.native="goSubCategories(item)" class=" mr-1 text-success" name="cil-people"/>-->

                  <CIcon @click.native="delete_item_dialog(item)" class=" mr-1 text-danger" name="cilTrash"/>
                </td>
              </template>


            </CDataTable>
          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import mapboxgl from 'mapbox-gl'


var items = [];


export default {
  name: 'Login',
  components: {},
  data() {
    return {
      confirm_delete_name: "confirm_area" + new Date().getTime() + "_" + this.$vnode.tag,
      map: null,
      edit_name: '',
      fields: [
        {key: 'row_id', label: this.$t('tables.row'), _style: 'width:10%'},
        {key: 'areaName', label: this.$t('tables.area'), _style: 'width:10%'},
        {key: 'provinceName', label: this.$t('tables.province'), _style: 'width:10%'},
        {key: 'cityName', label: this.$t('tables.city'), _style: 'width:10%;'},
        {key: 'regionName', label: this.$t('Town'), _style: 'width:10%;'},
        {key: 'operation', label: "", _style: 'width:10%;'},
      ],
      polygon_area: [
        [-67.13734351262877, 45.137451890638886],
        [-66.96466, 44.8097],
        [-68.03252, 44.3252],
        [-69.06, 43.98],
        [-70.11617, 43.68405],

      ],
      polygon_area_count: 0,
      polygon_draw: null,
      table_clicks_timer: null,
      table_clicks: 0,
      validate_errors: [],
      name: '',
      file: '',
      color: '#ffffff',
      previewImage: '',
      description: '',
      items: [],

      province_items: [],
      selected_province: 0,
      province_items2: [],
      selected_province2: 0,

      country_items: [],
      selected_country: 0,
      selected_country2: 0,

      city_items: [],
      city_items2: [],
      selected_city: 0,
      selected_city2: 0,

      district_items: [],
      selected_district: 0,
      district_items2: [],
      selected_district2: 0,


      details: [],
      collapseDuration: 0,
      status_form: 0
    }
  },
  created() {
  },
  mounted() {
    this.$root.root_validate_errors = [];


    // this.get_lists();
    this.get_country();
    bus.$on(this.confirm_delete_name + this.$route.path, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
    bus.$on("add_area_data_insert", (data) => {
      // alert(data);
      this.selected_country = data.country;
      this.selected_province = data.province;
      this.selected_city = data.city;
      this.selected_district = data.district;
     // console.log("add_area_data_insert",data,data.country)
    });
    if(this.get_access('area_map')){
      this.createMap();
    }

  }, watch: {
    'selected_city2': function () {
      this.get_districts2();
    },
    'selected_district': function () {
      this.get_lists();
    },
    'selected_province': function () {
      console.log("peovince changed");
      this.get_cities();
    },
    'selected_city': function () {
      this.get_districts();
    },
    'selected_country': function () {
      this.get_provinces();
    },
    'selected_province2': function () {
      this.get_cities2();
    },
    'selected_country2': function () {
      this.get_provinces2();
    }
  },
  methods: {
    get_country() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetCountries', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.country_items = [];
          self.country_items = self.sort_array(
              self.country_items, content_data.data,
              'id', 'title');

          self.selected_country = self.country_items[0].value;
          self.selected_country2 = self.country_items[0].value;
          if (self.$i18n.locale == 'fa') {
            self.selected_country = self.country_items.filter(x => x.label == 'ایران')[0].value
            self.selected_country2 = self.country_items.filter(x => x.label == 'ایران')[0].value
          }
          if (self.$i18n.locale == 'en') {
            self.selected_country = self.country_items.filter(x => x.label == 'England')[0].value
            self.selected_country2 = self.country_items.filter(x => x.label == 'England')[0].value
          }
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      }).catch(function (error) {

        console.log(error);
      });

    },

    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.edit_item(item)
        this.table_clicks = 0

      }
    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' && this.selected_province != 0 && this.selected_city != 0) {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('insertAreaName'));
      }
      if (this.selected_province == 0) {
        this.$root.root_validate_errors.push(this.$t('insertProvince'));
      }
      if (this.selected_city == 0) {
        this.$root.root_validate_errors.push(this.$t('insertCity'));
      }
      return false;
      // e.preventDefault();
    },
    createMap() {
      var self = this;
      // init the map
      mapboxgl.accessToken = 'pk.eyJ1Ijoib21kZXNobyIsImEiOiJjanoyaW1zNG4wMHI1M2JteTQyZXhqaTI3In0.M0GJxZnal_ysW7mxXWEZLg';
      var center_loc = [51.37734351262877, 35.697451890638886];
      if (self.$i18n.locale == 'en') {
        center_loc = [-0.03880407284764019, 51.573360744046745];
      }
      self.map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
        center: center_loc,
        zoom: 14 // starting zoom
      });
      // console.log("get rtl status ",mapboxgl.getRTLTextPluginStatus());
      if(mapboxgl.getRTLTextPluginStatus()=="unavailable") {
       mapboxgl.setRTLTextPlugin(
               'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
               null,
               true // Lazy load the plugin
       );
     }
      self.polygon_draw = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          polygon: true,
          trash: true
        }
      });
      self.map.addControl(self.polygon_draw);
      self.map.on('draw.create', self.updatePolygonArea);
      self.map.on('draw.delete', self.updatePolygonArea);
      self.map.on('draw.update', self.updatePolygonArea);

      // self.map.addControl(new mapboxgl.Navigation())
      // self.map.on('click', function(e) {
      //   var marker = new mapboxgl.Marker({
      //     draggable: true
      //   })
      //           .setLngLat(e.lngLat)
      //           .addTo(self.map);
      //   var polygon_obj = [0,0];
      //   polygon_obj[0] = e.lngLat.lng;
      //   polygon_obj[1] = e.lngLat.lat;
      //   console.log("poly obj "+polygon_obj);
      //   console.log("poly array "+self.polygon_area2);
      //
      //   self.polygon_area.push(self.polygon_area_count,e.lngLat);
      //   function onDragEnd() {
      //     var lngLat = marker.getLngLat();
      //
      //   }
      //   function onDragStart() {
      //     var lngLat = marker.getLngLat();
      //     console.log("drag started");
      //   }
      //
      //   marker.on('dragend', onDragEnd);
      //   marker.on('dragstart', onDragStart);
      //   console.log('A click event has occurred at ' + e.lngLat);
      // });

      self.map.on('load', function () {
        self.show_polygon();
      });
    },
    updatePolygonArea() {
      var data = this.polygon_draw.getAll();
      // console.log(data);
      if (data.features.length > 0) {
        this.polygon_area = data.features[0].geometry.coordinates;
        this.show_polygon();

      } else {
        this.polygon_area = [];
        this.show_polygon();

      }
    },
    show_polygon() {
      if (this.map.getLayer("maine") != null) {
        this.map.removeLayer("maine");

      }
      try {

        this.map.removeSource("maine");

      } catch (e) {
        console.log("layer not found");
      }
      this.map.addSource('maine', {
        'type': 'geojson',
        'data': {
          'type': 'Feature',
          'geometry': {
            'type': 'Polygon',
            'coordinates': this.polygon_area

          }
        }
      });
      this.map.addLayer({
        'id': 'maine',
        'type': 'fill',
        'source': 'maine',
        'layout': {},
        'paint': {
          'fill-color': '#088',
          'fill-opacity': 0.8
        }
      });


    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = item.areaName;
      this.edit_name = item.areaName;
      this.selected_province = item.provinceId;
      this.selected_city = item.cityId;
      this.selected_district = item.regionId;
      this.selected_country = item.countryId;
      this.get_cities();
      this.polygon_area = JSON.parse(item.areaRange);
      this.show_polygon();

      this.status_form = item.id;
      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_lists() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_district);


      axios.post('GetAreaTitlesByCityId', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goSubCategories(item) {

      this.$router.push({path: '/users/list-users/' + item.id});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },

    get_provinces() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_country);


      axios.post('GetStateList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.province_items = [];
          self.province_items = self.sort_array(
              self.province_items, content_data.data,
              'id', 'provinceName');

          if (self.status_form == 0) {

            self.selected_province = self.province_items[0].value
          }
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_provinces2() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_country2);


      axios.post('GetStateList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.province_items2 = [];
          self.province_items2 = self.sort_array(
              self.province_items2, content_data.data,
              'id','provinceName');


          if (self.status_form == 0) {
            self.selected_province2 = self.province_items2[0].value
          }

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_cities() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_province);

      axios.post('GetCityListByStateId', formData, {show_pros: true}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.city_items = []
          self.city_items = self.sort_array(
              self.city_items, content_data.data,
              'cityId', 'cityName');

          if (self.status_form == 0) {

            self.selected_city = self.city_items[0].value
          }
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }
      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_cities2() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_province2);

      axios.post('GetCityListByStateId', formData, {show_pros: true}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.city_items2 = []
          self.city_items2 = self.sort_array(
              self.city_items2, content_data.data,
              'cityId','cityName');

          if (self.status_form == 0) {
            self.selected_city2 = self.city_items2[0].value
          }
        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_districts() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_city);

      axios.post('GetRegionByCityId', formData, {show_pros: true}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.district_items = []
          self.district_items = self.sort_array(
              self.district_items, content_data.data,
              'id', 'title');

          if (self.status_form == 0) {
            self.selected_district = self.district_items[0].value;

          }

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_districts2() {
      var self = this;

      const formData = new FormData();


      formData.append('id', this.selected_city2);

      axios.post('GetRegionByCityId', formData, {show_pros: true}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.district_items2 = []
          self.district_items2 = self.sort_array(
              self.district_items2, content_data.data,
              'id', 'title');

          if (self.status_form == 0) {
            self.selected_district2 = self.district_items2[0].value;

          }

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    insert_data() {

      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }
      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddAreaTitle";
      } else {
        url = "EditAreaTitle";
        formData.append('id', this.status_form)

      }

      formData.append('ProvinceId', this.selected_province);
      formData.append('CityId', this.selected_city);
      formData.append('RegionId', this.selected_district);
      formData.append('AreaName', this.name);
      formData.append('AreaRange', JSON.stringify(this.polygon_area));
      axios.post(url, formData, {}).then((res) => {



        self.status_form = 0;
        self.name = '';
        self.color = '';
        self.description = '';
        self.previewImage = '';
        self.get_lists();
        bus.$emit("close_add_base_modal", 'true');

        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name + this.$route.path);

      this.status_form = this.items[item.row_id].id;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteAreaTitle";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
